export const hasDebugSwitch = (key: string) => {
  if (typeof window === 'undefined') {
    return false;
  }
  if (location.search.indexOf(key) !== -1) {
    return true;
  }
  // eslint-disable-next-line no-extra-boolean-cast
  if (Boolean(localStorage.getItem(key))) {
    return true;
  }
  return false;
};
